const runtimeHost =
  (typeof window !== 'undefined' && window.location && window.location.hostname) || '';

const API_BASE_URL =
  runtimeHost.includes('localhost')
    ? 'http://localhost:3000/api'
    : (runtimeHost.includes('sbx') || runtimeHost.includes('sandbox'))
      ? 'https://control-horas-backend-sbx.fly.dev/api'
      : 'https://control-horas-backend.fly.dev/api';
const REQUEST_ENV = (runtimeHost.includes('sbx') || runtimeHost.includes('sandbox')) ? 'sbx' : 'prod';
export default API_BASE_URL;

const getApiPath = (path) => (path.startsWith('/') ? path : `/${path}`);

const getApiUrl = (path) => {
  const hasApiInBase = API_BASE_URL.endsWith('/api');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  if (cleanPath.startsWith('/health/')) {
    const baseUrlWithoutApi = hasApiInBase ? API_BASE_URL.slice(0, -4) : API_BASE_URL;
    return `${baseUrlWithoutApi}${cleanPath}`;
  }
  const normalizedPath = hasApiInBase && cleanPath.startsWith('/api')
    ? cleanPath.slice(4) || '/' // strip leading '/api'
    : cleanPath;
  return `${API_BASE_URL}${normalizedPath}`;
};

function getToken() {
  if (typeof window === 'undefined') return null;
  try {
    return window.__SA_ACCESS_TOKEN__ || window.sessionStorage.getItem('sa_token') || null;
  } catch (_) {
    return window.__SA_ACCESS_TOKEN__ || null;
  }
}

function setToken(token) {
  if (typeof window !== 'undefined') {
    if (token) {
      window.__SA_ACCESS_TOKEN__ = token;
      try {
        window.sessionStorage.setItem('sa_token', token);
      } catch (_) {
        // Ignore storage restrictions (private mode, strict policies)
      }
    } else {
      delete window.__SA_ACCESS_TOKEN__;
      try {
        window.sessionStorage.removeItem('sa_token');
      } catch (_) {
        // Ignore storage restrictions
      }
    }
  }
}

export async function api(path, options = {}) {
  const url = getApiUrl(path);
  const normalizedPath = getApiPath(path).toLowerCase();
  const isPublicLoginFlow =
    normalizedPath === '/superadmin/auth/login' ||
    normalizedPath === '/superadmin/auth/verify-2fa';
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    'x-env': REQUEST_ENV,
    ...options.headers
  };
  let res;
  try {
    res = await fetch(url, {
      ...options,
      credentials: 'include',
      headers
    });
  } catch (err) {
    const networkError = new Error('No se pudo conectar con el backend (revisa URL base, CORS o tu conexión).');
    networkError.cause = err;
    networkError.isNetworkError = true;
    throw networkError;
  }
  // Handle 204 No Content gracefully
  const data = res.status === 204 ? {} : await res.json().catch(() => ({}));
  if (!res.ok) {
    if (
      typeof window !== 'undefined' &&
      (res.status === 401 || res.status === 403) &&
      !isPublicLoginFlow
    ) {
      setToken(null);
      window.location.href = '/login';
      return Promise.reject(new Error('Sesión expirada'));
    }
    const err = new Error(
      data.error ||
        res.statusText ||
        `Error en la solicitud (HTTP ${res.status})`
    );
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export function apiPost(path, body) {
  return api(path, { method: 'POST', body: JSON.stringify(body || {}) });
}
export function apiPatch(path, body) {
  return api(path, { method: 'PATCH', body: JSON.stringify(body || {}) });
}
export function apiDelete(path) {
  return api(path, { method: 'DELETE' });
}

export async function checkAuth() {
  try {
    const res = await api('/superadmin/auth/me');
    return { ok: true, user: res.user, preferences: res.preferences };
  } catch (_) {
    return { ok: false };
  }
}

export function logout() {
  setToken(null);
  fetch(`${API_BASE_URL}${getApiPath('/superadmin/auth/logout')}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'x-env': REQUEST_ENV
    }
  }).catch(() => {});
  window.location.href = '/login';
}

export { getToken, setToken };
